//PRD

const config = {
    timeTable: 500,
    region:"us-west-2",
    cognito:{
       iss : 'https://cognito-idp.us-west-2.amazonaws.com/us-west-2_XEpXQ8xgs',
       poolData: {
         UserPoolId:"us-west-2_XEpXQ8xgs",
         ClientId:"1kebrnq22qmqvcrna5adppic59",
       },
       identityPoolId: 'us-west-2:5e24bb40-b054-4e5d-a384-7a12ca0792e2',
       logins: "cognito-idp.us-west-2.amazonaws.com/us-west-2_XEpXQ8xgs",
       pems : { 'xlMYxvRBwDg/ET19RnWwFRst1lpPlJn5SJkdh3/CU5A=': '-----BEGIN RSA PUBLIC KEY-----\nMIIBCgKCAQEAgPBZSuN+vDGL1vibUOJX/TVOfdTWefb0LanBGzOXo6rUzSa2mEIm\n1uAwB/goGfyzfryUOexzuUFP3JAxiTMvP8VLYKEa9+4yO8GS1J5qghmz/d3h9yMq\nTrLvhiY54Vw68IpKLPw3TWPARSCH2A0JSsQkHLSGc+LOpN/yjYGeuXXi2dPYa7oO\nppyOD3rl6VdoyHDmzgVnMi/WE+ZUpMufadIwGDStvwIqoQO49pvmW1CgQXT0DE5m\ncEJdrFpfObYxnBrqonkyCk0eK8sCsZcDC8ltjQo0+WfHbLhoPxDfnPqoENXK9G3S\n9K7jZJenLuNxZkvR7IfMjAuBzFKGqhVNiQIDAQAB\n-----END RSA PUBLIC KEY-----\n',
                '1Io5ybFNIvqwjQGePIfxUdQkvDVDpn1US6QkF32Oq9Q=': '-----BEGIN RSA PUBLIC KEY-----\nMIIBCgKCAQEAvYyWusslmBhKflSQAneEFeUanuPDBus7PtcyQHPlnTrPK5FEZnPX\n6Viaw0V/3kzpFY1Kbcw8sGM1QC1dvnb6Gf9KwmAX6gKTqutRIfoLaA0BY80v5j9V\n5HQ0qXfET1B19WjkjX7OLJnuESQyrWbNkO70UnHtr+b0Zah2maMsmHf0o+arOdsr\nkmC2+qVBIBA4mCmn0lUEmD+6oMwYySgklbqR6wysq0KGAYti6cFVXn8y7vVNv6b2\nW6DO87Hf96WWrfok7wA8c4+ZvjvGPuY0/o47KPpOwTw+49c2sOXs+DdbHYXwawU3\nWpDgPCd1UEEy4eNRjCRBiUXFppRZI78nFQIDAQAB\n-----END RSA PUBLIC KEY-----\n' }
    },
    api:{
       endpoint:"https://slcjt6xrv0.execute-api.us-west-2.amazonaws.com/prd/"
    },
    charList: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%&*(){[=]+-}",
    cookie:{
        cookieName : "hash",
        cookieTime : 120, // tempo de vida em minutos
    },
    cookieIdioma: {
        cookieName: "idioma",
        cookieTime: 5259600, // tempo de vida em minutos
    },
    cookieTempIdioma: {
        cookieName: "temp-idioma",
        cookieTime: 5, // tempo de vida em minutos
    },
    token: {
        renewDelay: 1800, // numero de minutos * 60 (30*60=1800)
    },
    inscricoes: {
        modalidades: [{"id": "","nome":"selecione"}, {"id": "1","nome":"auto-desafio"},{"id":"2" ,"nome": "confronto"}],
    },
    gruposPermissoes: {
        Admin: {id: 1, nome: 'Administrador', nivel: 1},
        Geral: {id: 2, nome: 'Geral', nivel: 2},
        Nacional: {id: 5 , nome: 'Nacional', nivel: 3},
        Regional: {id: 3, nome: 'Regional', nivel: 3},
        Assistente: {id: 4, nome: 'Assistente', nivel: 4}
    },
    debug: false,
    multiLanguage: false,
    idioma: {
        "pt-br": "Português",
        "en": "English",
        "es": "Español"
    },
    categorias: [
        {"id": 1, "desc" : "categoria-1"},
        {"id": 2, "desc" : "categoria-2"},
        {"id": 3, "desc" : "categoria-3"},
        {"id": 4, "desc" : "categoria-4"},
        {"id": 5, "desc" : "categoria-5"},
        {"id": 6, "desc" : "categoria-6"},
        {"id": 7, "desc" : "categoria-7"}
    ]
}

export default config;


// WEBPACK FOOTER //
// ./src/config/config.js